(function () {
  if(document.body.id !== 'top') return false

  //マップ
  var overlay = document.querySelector('.js-top-map-overlay')
  var slider = overlay.querySelector('.js-top-map-slider')
  var close = overlay.querySelector('.close')

  setSwiper(slider)

  var swiper= new Swiper('.js-top-map-slider', {
    speed: 300,
    effect: 'fade',
    loop: true,
    navigation: {
      nextEl: '.js-top-map-next',
      prevEl: '.js-top-map-prev',
    },
    breakpoints: {
      1200: {
        allowTouchMove: false
      }
    }
  })

  function setSwiper(slideContainer) {
    slideContainer.classList.add('swiper-container')
    var slideWrapper = slideContainer.querySelector('.wrapper')
    slideWrapper.classList.add('swiper-wrapper')
    var slide = slideWrapper.querySelectorAll('.slide')
    for (var i = 0; i < slide.length; i++) {
      slide[i].classList.add('swiper-slide')
    }
  }

  var marker = document.querySelectorAll('.js-map-marker')
  for(var i=0; i < marker.length; i++) { 
    marker[i].addEventListener('click', objClick)
  }

  var slideAll = [].slice.call(document.querySelectorAll('.js-map-slide'))

  function objClick(e) {
    var slide =document.querySelector('.js-map-slide-'+e.currentTarget.getAttribute('data-target'))
    swiper.slideToLoop(slideAll.indexOf(slide)-1, 0)
    overlay.classList.add('is-show')
  }

  var close = document.querySelector('.js-top-map-close')
  close.addEventListener('click', mapClose)

  function mapClose() {
    overlay.classList.remove('is-show')
    inner.classList.remove('is-hide')
  }



}());
